import { render, staticRenderFns } from "./BannerQuitarAds.vue?vue&type=template&id=340352e8&scoped=true"
import script from "./BannerQuitarAds.vue?vue&type=script&lang=js"
export * from "./BannerQuitarAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340352e8",
  null
  
)

export default component.exports